import * as React from "react"
import ChaptersService from '../../../../service/sfp/chapters-service';
import InstructionCardComponent from "./instruction-card-component"
import * as Model from "../../../../model"
import Chapter from "../../../../model/chapter";

class InstructionCard extends React.Component<InstructionCardProps, State> {
    constructor(props) {
        super(props)
        this.state = {
            loadingInstruction: false,
            loadingChapters: false,
            accounts: [],
            chapters: []
        }
    }

    componentWillReceiveProps(props) {
        if (!props.localAuthority || 0 !== this.state.chapters.length || this.state.loadingChapters) return
        const accounts = props.localAuthority.accounts
        this.getChapters(props.localAuthority.instruction)
        this.setState({ accounts, loadingInstruction: false })
    }

    render() {
        const loading = this.props.loading || this.state.loadingInstruction || this.state.loadingChapters
        return <InstructionCardComponent
            accounts={this.state.accounts}
            chaptersNumber={this.state.chapters.length}
            loading={loading}
            localAuthority={this.props.localAuthority}
            lacaNumber={this.getLacaNumberCustom()} />
    }

    getLacaNumberCustom() {
        let number = 0
        this.state.accounts.forEach(laca => {
            if (!laca.account.template) number += 1
        })
        return number
    }

    getChapters(
		/** @type {Instruction} */ instruction
    ) {
        this.setState({ loadingChapters: true })
        ChaptersService.findChaptersByInstruction(instruction)
            .then(this._resolveFindChapters.bind(this, instruction), this._rejectFindChapters);
    }

    _rejectFindChapters = (error) => {
    }

    _resolveFindChapters = (
		/** @type {Object} */ response) => {
        this.setState({ chapters: response, loadingChapters: false })
    }

}

export default InstructionCard

export interface InstructionCardProps {
    loading: boolean
    localAuthority: Model.LocalAuthority
}

interface State {
    loadingInstruction: boolean
    loadingChapters: boolean
    accounts: Model.LocalAuthorityChapterAccount[]
    chapters: Chapter[]
}



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/index.tsx